import React from 'react';

export default function ServiceFAQList({ items = [] }) {
  return (
    <div className="divide-y divide-brown/15">
      {items.map(({ question, answer }, index) => (
        <details key={question} open={index === 0} className="group py-1">
          <summary className="cursor-pointer list-none flex items-center justify-between gap-5 py-5 focus-visible:outline focus-visible:outline-2 focus-visible:outline-gold focus-visible:outline-offset-4 rounded-card-sm [&::-webkit-details-marker]:hidden">
            <h3 className="aeo-question font-serif text-h3 text-warm-black font-medium leading-snug">{question}</h3>
            <span aria-hidden="true" className="text-gold text-xl shrink-0"><span className="group-open:hidden">+</span><span className="hidden group-open:inline">−</span></span>
          </summary>
          <p className="aeo-answer text-body text-muted leading-[1.75] max-w-reading pb-6 break-words whitespace-pre-line">{answer}</p>
        </details>
      ))}
    </div>
  );
}